/** @forge-header
 * @id          showMoreFooter
 * @role        Expand/collapse footer with game count display
 * @pattern     component
 * @tier        T3
 * @purity      none
 * @upstream    lucide-react:ChevronUp,ChevronDown
 * @downstream  ConsolidatedMoneylines
 * @exports     ShowMoreFooter:component | ShowMoreFooterProps:interface
 * @test        untested
 */

import { ChevronDown, ChevronUp } from 'lucide-react';

export interface ShowMoreFooterProps {
  totalCount: number;
  visibleCount: number;
  showAll: boolean;
  onToggle: () => void;
}

export function ShowMoreFooter({
  totalCount,
  visibleCount,
  showAll,
  onToggle,
}: ShowMoreFooterProps) {
  return (
    <div className="border-border/50 flex items-center justify-center border-t p-2">
      <button
        type="button"
        onClick={onToggle}
        className="text-muted-foreground hover:text-foreground hover:bg-muted/30 flex items-center gap-2 rounded px-3 py-1.5 text-xs transition-colors"
        aria-expanded={showAll}
        aria-label={showAll ? 'Show fewer games' : 'Show more games'}
      >
        <span className="tabular-nums">
          {showAll ? `Showing ${totalCount}` : `Showing ${visibleCount} of ${totalCount}`}
        </span>
        {showAll ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
    </div>
  );
}
